import View from './ActionMenu.view';

export default View;
